import { render, staticRenderFns } from "./ResearchNodeList.vue?vue&type=template&id=57dfcf2f&scoped=true"
import script from "./ResearchNodeList.vue?vue&type=script&lang=ts"
export * from "./ResearchNodeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfcf2f",
  null
  
)

export default component.exports